/**
 * The languages a school's product mail can be written in
 * ([ADR-0056](../../../docs/decisions/0056-product-mail-speaks-the-schools-language-and-reads-two-branding-keys.md)).
 *
 * The same set as `ck_tenant_locale`. A third language is a migration, a copy
 * table in notification-svc, and an entry here — together.
 */
export const LOCALES = ['ro', 'en'];
/** Every school that exists today is in Romania. */
export const DEFAULT_LOCALE = 'ro';
export function isLocale(value) {
    return typeof value === 'string' && LOCALES.includes(value);
}
//# sourceMappingURL=locale.js.map